import { connect } from 'react-redux';
import AuctionsList from 'components/auctions/AuctionsList';
import {
  fetchPendingApprovalAuctions,
  startAuctions,
  cancelAuctions,
} from 'data/auctions/Auctions.actions';

import { AuctionStatuses } from 'vdlib';
import {
  getMapStateToProps,
  getMapDispatchToProps,
} from './common/DefaultMapProps';

const mapStateToProps = state => {
  return Object.assign({}, getMapStateToProps(state), {
    lang: state.i18n.locale,
    auctionStatus: AuctionStatuses.Pending,
    fetchingAuctions: state.auctions.fetchingPendingApprovalAuctions,
    auctions: state.auctions.pendingApprovalAuctions,
    submitting: state.auctions.startingAuctions,
    cancelling: state.auctions.cancellingAuctions,
  });
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return Object.assign({}, getMapDispatchToProps(dispatch), {
    fetchAuctions: skipStep => dispatch(fetchPendingApprovalAuctions(skipStep)),
    startAuctions: (auctionData, comments) =>
      dispatch(startAuctions(auctionData, comments)),
    cancelAuctions: auctionData => dispatch(cancelAuctions(auctionData)),
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(AuctionsList);
